<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer011">
<p class="basic-paragraph"><span class="charoverride4"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride4">Epigraphs</span></h1>
<p class="basic-paragraph5"><span class="charoverride6"><br class="calibre1"/></span></p>
<p class="basic-paragraph5"><span class="charoverride6">“No, all we need to do is buy up the ground from under their feet—and evict them. We’re buying up the planet, Bishop, fair and square. We’re turning it into the most exclusive gated community in history…”</span></p>
<p class="basic-paragraph6"><span class="charoverride6">—</span><span class="charoverride6">David Marusek, </span><span class="charoverride7">Mind Over Ship</span></p>
<p class="basic-paragraph5"><span class="charoverride6"><br class="calibre1"/></span></p>
<p class="basic-paragraph5"><span class="charoverride6">“Forces beyond your control can take away everything you possess except one thing, your freedom to choose how you will respond to the situation.”</span></p>
<p class="basic-paragraph6"><span class="charoverride6">—Victor E. Frankl, </span><span class="charoverride7">Man’s Search for Meaning </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraphs.vue?3845d4b4